import { apiRequest } from './client';
import { AtsName } from '@outlinked/shared';
import type { ErrorFinding, FindingStatus, FindingCategory } from '@outlinked/shared';

// Re-export canonical shapes — page components continue to import from
// this file. `Finding` is a back-compat alias for ErrorFinding to keep
// existing call sites compiling.
// AtsName is re-exported as a value so page components can use AtsName.options at runtime.
export { AtsName };
export type { ErrorFinding, FindingStatus, FindingCategory };
export type AtsNameType = typeof AtsName._type;
export type Finding = ErrorFinding;

export interface FindingsListResponse {
  items: ErrorFinding[];
  nextCursor: string | null;
}

export interface ListFindingsOpts {
  status?: FindingStatus;
  category?: string;
  ats?: AtsName;
  cursor?: string;
  limit?: number;
}

export function listFindings(opts: ListFindingsOpts = {}): Promise<FindingsListResponse> {
  const params = new URLSearchParams();
  if (opts.status) params.set('status', opts.status);
  if (opts.category) params.set('category', opts.category);
  if (opts.ats) params.set('ats', opts.ats);
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  return apiRequest<FindingsListResponse>(`/findings?${params}`);
}

export function getFinding(status: FindingStatus, id: string): Promise<ErrorFinding> {
  return apiRequest<ErrorFinding>(`/findings/${status}/${id}`);
}

export function patchFinding(
  status: FindingStatus,
  id: string,
  patch: { status?: FindingStatus; prUrl?: string; prState?: string },
  reason: string,
): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/findings/${status}/${id}?reason=${encodeURIComponent(reason)}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
